<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.dateRange }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker
                            v-model="forms.commDateFrom"
                            :label="labels.commDateFrom"
                            :data-vv-as="labels.commDateFrom"
                            data-vv-name="forms.commDateFrom"
                            :error-messages="errors.collect('forms.commDateFrom')"
                            v-validate="commDateFromValidation"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker
                            v-model="forms.commDateTo"
                            :label="labels.commDateTo"
                            :data-vv-as="labels.commDateTo"
                            data-vv-name="forms.commDateTo"
                            :error-messages="errors.collect('forms.commDateTo')"
                            v-validate="commDateToValidation"
                          ></cal-picker>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>

        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.filters }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <!-- Department -->
                        <v-flex lg6 xs6>
                          <v-autocomplete
                            :items="allSelectedList"
                            v-model="forms.dept"
                            :label="labels.dept"
                            item-text="label"
                            item-value="value"
                            data-vv-name="dept"
                            :data-vv-as="labels.dept"
                            :error-messages="errors.collect('dept')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-if="forms.dept === 'Selected'">
                          <v-autocomplete
                            :items="deptList"
                            v-model="forms.deptSelected"
                            :label="labels.deptSelected"
                            item-text="label"
                            item-value="value"
                            multiple
                            data-vv-name="deptSelected"
                            :data-vv-as="labels.deptSelected"
                            :error-messages="errors.collect('deptSelected')"
                            v-validate="'required'"
                            :loading="loading"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-else></v-flex>

                        <!-- Policy Status -->
                        <v-flex lg6 xs6>
                          <v-autocomplete
                            :items="allSelectedList"
                            v-model="forms.polStat"
                            :label="labels.polStat"
                            item-text="label"
                            item-value="value"
                            data-vv-name="polStat"
                            :data-vv-as="labels.polStat"
                            :error-messages="errors.collect('polStat')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-if="forms.polStat === 'Selected'">
                          <v-autocomplete
                            :items="polStatList"
                            v-model="forms.polStatSelected"
                            :label="labels.polStatSelected"
                            item-text="label"
                            item-value="value"
                            multiple
                            data-vv-name="polStatSelected"
                            :data-vv-as="labels.polStatSelected"
                            :error-messages="errors.collect('polStatSelected')"
                            v-validate="'required'"
                            :loading="loading"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-else></v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-btn color="error" dark :loading="processing" @click.prevent="doPromptDelete">
            <v-icon dark left>mdi-delete</v-icon>
            {{ labels.deleteRenewals }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="processing" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <v-subheader>Oops something went wrong:</v-subheader>
            <ul class="showErrorMsgs">
              <li v-for="(error, index) in messages" :key="index">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <confirm v-model="promptDelete" @ok="doSubmit">Confirm Deletion of Renewals?</confirm>

    <v-dialog v-model="promptExeJob" width="500px" persistent>
      <batch-job-scheduler
        v-if="promptExeJob"
        :skipValidate="batchForm.skipValidate"
        :jobKeys="forms"
        :showJobMode="false"
        @close="promptExeJob = false"
        @doPopulate="processBatch($event)"
      />
    </v-dialog>

    <warning v-model="promptResubmit" @ok="doAccept">
      <div>{{ warningMsg1 }}</div>
      <div class="queryValue" v-for="(item, index) in bchJobDetails" :key="index">{{ item }}</div>
      <div>{{ warningMsg2 }}</div>
    </warning>
 </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import BatchJobScheduler from '@/components/core/common/BatchJobScheduler'
import { batchManagerMixin } from '@/mixins/common/batchManagerMixin'

export default {
  data() {
    return {
      labels: {
        dateRange: 'Date Range',
        commDateFrom: 'Commencement Date From*',
        commDateTo: 'Commencement Date To*',
        filters: 'Filters',
        dept: 'Department',
        polStat: 'Policy Status',
        deptSelected: 'Selected Department',
        polStatSelected: 'Selected Policy Status',
        deleteRenewals: 'Delete Renewals'
      },
      forms: {
        commDateFrom: null,
        commDateTo: null,
        dept: 'All',
        deptSelected: null,
        polStat: 'All',
        polStatSelected: null
      },
      loading: false,
      processing: false,
      showErrorDialog: false,
      allSelectedList: [
        {
          label: 'All',
          value: 'All'
        },
        {
          label: 'Selected',
          value: 'Selected'
        }
      ],
      deptList: [],
      polStatList: [],
      promptDelete: false,
      panel1: [0],
      panel2: [0]
    }
  },
  computed: {
    commDateFromValidation() {
      if (this.forms.commDateFrom !== '' && this.forms.commDateFrom !== null && this.forms.commDateFrom !== undefined) {
        return 'entry|valCommDateFrom:' + this.forms.commDateTo
      } else {
        return 'required'
      }
    },
    commDateToValidation() {
      if (this.forms.commDateTo !== '' && this.forms.commDateTo !== null && this.forms.commDateTo !== undefined) {
        return 'entry|valCommDateTo:' + this.forms.commDateFrom
      } else {
        return 'required'
      }
    },
    displayErrorDialog() {
      return this.messages
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  methods: {
    doInit() {
      this.getParameters()
    },
    async getParameters() {
      const apiUrl = this.$store.state.underwriting.specialFuncUWSettings.menu.initDeleteUnreleasedRenewals
      if (apiUrl) {
        try {
          this.loading = true
          const result = await this.$http.get(apiUrl)
          if (result.data.deptList) {
            this.$set(this, 'deptList', result.data.deptList)
          }

          if (result.data.polStatList) {
            this.$set(this, 'polStatList', result.data.polStatList)
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.[initDeleteUnreleasedRenewals]')
      }
    },
    doPromptDelete() {
      this.promptDelete = true
    },
    doSubmit() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.isBatchManager === true) {
            this.promptExeJob = true
          } else {
            this.processBatch()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processBatch(bmForms) {
      let apiUrl = this.getProcessBatchUrl()
      let form = this.isBatchManager === true ? bmForms : this.forms
      if (apiUrl) {
        try {
          this.processing = true
          const result = await this.$http.post(apiUrl, form)
          if (result.data) {
            this.insideProcessBatch(result)
          }
          this.processing = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.processing = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.[deleteUnreleasedRenewals]')
      }
      this.batchForm.skipValidate = false
    },
    insideProcessBatch(result) {
      if (this.isBatchManager === true) {
        const { data } = result.data
        if (data.prevBchJobs && data.prevBchJobs.length > 0) {
          this.promptResubmit = true
          this.getBchJobDetails(data.prevBchJobs)
        }
      } else {
        this.$toast.success('Job successfully submitted to batch job process.')
      }
    },
    getProcessBatchUrl() {
      if (this.isBatchManager === true) {
        return this.$store.state.underwriting.specialFuncUWSettings.menu.exeDeleteUnreleasedRenewals
      } else {
        return this.$store.state.underwriting.specialFuncUWSettings.menu.deleteUnreleasedRenewals
      }
    }
  },
  created() {
    this.$validator.extend('valCommDateFrom', {
      getMessage(field, args) {
        return 'Must be same date or earlier date than To Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranFromDate = args[0]
        if (tranFromDate) {
          return !isAfter(removeTime(value), removeTime(tranFromDate))
        }
      }
    })

    this.$validator.extend('valCommDateTo', {
      getMessage(field, args) {
        return 'To Date must be greater or equal to From Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranToDate = args[0]
        if (tranToDate) {
          return !isAfter(removeTime(tranToDate), removeTime(value))
        }
      }
    })
  },
  beforeMount() {
    if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
      this.$store.dispatch('specialFuncUWInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin, batchManagerMixin],
  components: {
    BatchJobScheduler
  }
}
</script>

<style>
</style>
